// extracted by mini-css-extract-plugin
export var redeemQuote = "style-module--redeemQuote--cef68";
export var retrieveQuote = "style-module--retrieveQuote--918ca";